import './language-switch.scss';

class LanguageSwitch {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-language-switch',
            openClass: 'language-switch--open'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$languageSwitch = $element;
        this.$trigger = this.$languageSwitch.querySelector(`[${this.settings.initAttr}="trigger"]`);

        this.isOpen = false;

        if (this.$trigger) {
            this.initialize();
        }
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggle();
        });

        document.addEventListener('click', (e) => {
            if (this.isOpen && !this.$languageSwitch.contains(e.target)) {
                this.close();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
                this.$trigger.focus();
            }
        });
    }

    toggle () {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open () {
        this.isOpen = true;
        this.$languageSwitch.classList.add(this.settings.openClass);
        this.$trigger.setAttribute('aria-expanded', 'true');
    }

    close () {
        this.isOpen = false;
        this.$languageSwitch.classList.remove(this.settings.openClass);
        this.$trigger.setAttribute('aria-expanded', 'false');
    }
}

export { LanguageSwitch };

window.addEventListener('content.loaded', (e) => {
    const { $context } = e.detail;

    if ($context) {
        const $$languageSwitches = $context.querySelectorAll('[data-language-switch="root"]');
        $$languageSwitches.forEach($languageSwitch => {
            const languageSwitchAPI = new LanguageSwitch($languageSwitch);
            $languageSwitch.API = languageSwitchAPI;
        });
    }
});
